export const filterResourceBySearch = <T extends { [key: string]: any }>(
  resourceArr: T[],
  key: keyof T,
  search: string,
) => {
  return resourceArr.filter((item) => item[key].toLowerCase().includes(search.toLowerCase()));
};
